import { Badge, Button, Dropdown, Menu} from 'antd';
import {
    BookOutlined,
    FireOutlined,
    TeamOutlined,
    HomeOutlined,
    MenuOutlined,
    SearchOutlined,
    ShoppingCartOutlined,
    UserOutlined,
    PoweroffOutlined,
  } from '@ant-design/icons';
import './header.css'
import { Link } from 'react-router-dom';
import { headerState } from './HeaderState';
import { observer } from 'mobx-react';
import type { MenuProps } from 'antd';
import { storageService } from '../../../utilities/service/StorageService';
import { useEffect, useState } from 'react';
import { toastMsg } from '../../../utilities/helpers/ToastHelper';
const Header = ()=>{
    headerState.checkLoginStatus();
    const itemValue = storageService.getSelectedItemInMainMenu();
    headerState.orderedDishAmount = storageService.getDishInCartAmount()!;
    useEffect(()=>{
        headerState.orderedDishAmount = storageService.getDishInCartAmount()!;
        headerState.selectedMainMenuItem = itemValue !== null ? itemValue : (itemValue === '' ? '' : 'home');
    },[headerState.amount])
    headerState.selectedMainMenuItem = itemValue !== null ? itemValue : (itemValue === '' ? '' : 'home');
    const userDropdown: MenuProps['items'] = [
        {key: '1',
        label: (<Link to={'/user'}>Tài khoản của tôi</Link>),
        icon: <UserOutlined/>},
        {key: '2',
        label: (<Link to={'/'} onClick={()=>{headerState.logOutAction()}}>Đăng xuất</Link>),
        icon: <PoweroffOutlined/>},
    ];
    const mobileMenuItems: MenuProps['items'] = 
    [   
        {key: '1',
        label: (<Link to={'/'}>Trang chủ</Link>),
        icon: <HomeOutlined/>},
        {key: '2',
        label: (<Link to={'/menu'}>Thực đơn</Link>),
        icon: <BookOutlined/>},
        {key: '3',
        label: (<Link to={'/about'}>Giới thiệu</Link>),
        icon: <TeamOutlined/>},
        {key: '4',
        label: (<Link to={'/reservation'}>Đặt bàn tại cửa hàng</Link>),
        icon: <FireOutlined/>},
        {key: '5',
        label: (<>{headerState.loginStatus ? <Dropdown menu={{ items: userDropdown }} placement="bottomRight" arrow>
            <Button type='text' style={{backgroundColor: 'transparent'}} danger>Người dùng</Button>
        </Dropdown> : <Button type='primary' danger><Link to={'/login'}>Đăng nhập</Link></Button>}</>)}
    ]
    return(
    <header className="header container mx-auto py-3">
        <Link to={'/'} className="header-logo" onClick={()=>{storageService.setMealType('all'); headerState.selectedMainMenuItem = 'home'; storageService.setSelectedItemInMainMenu('home')}}>
            <h1 className='text-4xl font-extrabold text-signature'>Nhoằm nhoằm</h1>
        </Link>
        <div className="header-menu flex-1 max-lg:hidden">
            <Menu className="header-menu-content max-lg:hidden" mode='horizontal' selectedKeys={[headerState.selectedMainMenuItem!]} onClick={(event)=>{headerState.handleSelectedItemMenu(event.key); storageService.deleteMealType()}}>
                <Menu.Item icon={<HomeOutlined/>} key={'home'} className="header-menu-item text-base">
                    <Link to={'/'}>Trang chủ</Link>
                </Menu.Item>
                <Menu.Item icon={<BookOutlined/>} key={'menu'} className="header-menu-item text-base">
                    <Link to={'/menu'}>Thực đơn</Link>
                </Menu.Item>
                <Menu.Item icon={<TeamOutlined/>} key={'about'} className="header-menu-item text-base">
                    <Link to={'/about'}>Giới thiệu</Link>
                </Menu.Item>
                <Menu.Item icon={<FireOutlined/>} key={'discount'} className="header-menu-item text-base">
                    <Link to={'/reservation'}>Đặt bàn tại cửa hàng</Link>
                </Menu.Item>
            </Menu>
        </div>
        <div className="header-action max-lg:hidden flex gap-4">
            <Badge count={headerState.orderedDishAmount}>
                <Button type='text' danger title='Giỏ hàng' className='text-3xl p-0' style={{backgroundColor: 'transparent'}}>
                    <Link to={'/cart'} onClick={()=>{headerState.selectedMainMenuItem = ''; storageService.setSelectedItemInMainMenu('')}}>
                        <ShoppingCartOutlined/>
                    </Link>
                </Button>
            </Badge>
            <>
                {headerState.loginStatus ? (<>
                    <Dropdown menu={{ items: userDropdown }} placement="bottomRight" arrow>
                        <Button type='text' style={{backgroundColor: 'transparent'}} danger>Người dùng</Button>
                    </Dropdown>
                </>):
                (<>
                    <Button type='primary' onClick={()=>{headerState.selectedMainMenuItem = ''; storageService.setSelectedItemInMainMenu('')}} danger>
                        <Link to={'/login'}>Đăng nhập</Link>
                    </Button>
                </>)}
            </>
        </div>
        <div className=' lg:hidden flex gap-3 items-center'>
            <Badge count={headerState.orderedDishAmount}>
                <Button type='text' danger title='Giỏ hàng' className='text-3xl p-0' style={{backgroundColor: 'transparent'}}>
                    <Link to={'/cart'} onClick={()=>{headerState.selectedMainMenuItem = ''; storageService.setSelectedItemInMainMenu('')}}>
                        <ShoppingCartOutlined/>
                    </Link>
                </Button>
            </Badge>
            <Dropdown menu={{items: mobileMenuItems}} placement='bottomRight' overlayClassName='header-menu--mobile lg:hidden'>
                <Button className='' icon={<MenuOutlined/>} danger ghost></Button>
            </Dropdown>
        </div>
    </header>)
}
export default observer(Header)